var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"id":"milk-vats-list","items":_vm.vats,"fields":_vm.vatFields,"hover":"","striped":""},on:{"row-clicked":_vm.onVatClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }